import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import CustomerLogin from './pages/LoginRegister';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import CategoryFull from './pages/CategoryFull';
import ItemDetails from './pages/ItemDetails';
import FAQ from './pages/FAQ';
import AboutUs from './pages/AboutUs';
import Terms from './pages/Terms';
import Warranty from './pages/Warranty';
import Affiliate from './pages/Affiliate';
import Cart from './pages/Cart';
import CustomerOrders from './pages/CustomerOrders';
import Address from './pages/Address';
import UpdateAddress from './pages/EditAddress';
import Search from './pages/Search';
import Checkout from './pages/Checkout';
import Confirmation from './pages/Confirmation';
import ThankYou from './pages/ThankYou';
import OrderDetails from './pages/OrderDetails';
import Support from './pages/Support';




const Routes = () => (
  <Switch >
    <Route exact path="/" component={CustomerLogin} />

    <Route path="/reset-password" component={ResetPassword} />
    <Route path="/forgot-password" component={ForgotPassword} />
    <Route path="/home" component={Home} />
    <Route path="/category" component={CategoryFull} />
    <Route path="/category/:id" component={CategoryFull} />
    <Route path="/detail-1" component={ItemDetails} />
    <Route path="/faq" component={FAQ} />
    <Route path="/terms-conditions" component={Terms} />
    <Route path="/about-us" component={AboutUs} />
    <Route path="/warranty" component={Warranty} />
    <Route path="/cart" component={Cart} />
    <Route path="/orders" component={CustomerOrders} />
    <Route path="/address" component={Address} />
    <Route path="/edit-address" component={UpdateAddress} />
    <Route path="/search" component={Search} />
    <Route path="/checkout" component={Checkout} />
    <Route path="/checkout-confirm" component={Confirmation} />
    <Route path="/order-deatils" component={OrderDetails} />
    <Route path="/thank-you" component={ThankYou} />
    <Route path="/support" component={Support} />

    {/* <Route path="/affiliate" component={Affiliate} />  */}

    <Route path="" component={NotFound} />

  </Switch>
);

export default Routes;
